import { CaretDownIcon } from './CaretDownIcon';
import { CalendarClockIcon } from './CalendarClockIcon';
import { CheckCircleIcon } from './CheckCircleIcon';
import { CheckMarkIcon } from './CheckMarkIcon';
import { EditIcon } from './EditIcon';
import { ExclamationIcon } from './ExclamationIcon';
import { FilterSliderIcon } from './FilterSliderIcon';
import { InfoIcon } from './InfoIcon';
import { LocalOfferIcon } from './LocalOfferIcon';
import { MailIcon } from './MailIcon';
import { MathSymbolsIcon } from './MathSymbolsIcon';
import { MoneyHandIcon } from './MoneyHandIcon';
import { MoneyOffIcon } from './MoneyOffIcon';
import { PhoneIcon } from './PhoneIcon';
import { QuestionMarkIcon } from './QuestionMarkIcon';
import { ExclamationFilledIcon } from './ExclamationFilledIcon';
import { SpecialOfferIcon } from './SpecialOfferIcon'

export { CalendarClockIcon, CaretDownIcon, CheckCircleIcon, CheckMarkIcon, EditIcon, ExclamationIcon, ExclamationFilledIcon, FilterSliderIcon, InfoIcon, LocalOfferIcon, MailIcon, MathSymbolsIcon, MoneyHandIcon, MoneyOffIcon, PhoneIcon, QuestionMarkIcon, SpecialOfferIcon };

export default {
    CalendarClockIcon,
    CaretDownIcon,
    CheckCircleIcon,
    CheckMarkIcon,
    EditIcon,
    ExclamationIcon,
    ExclamationFilledIcon,
    FilterSliderIcon,
    InfoIcon,
    LocalOfferIcon,
    MailIcon,
    MathSymbolsIcon,
    MoneyHandIcon,
    MoneyOffIcon,
    PhoneIcon,
    QuestionMarkIcon,
    SpecialOfferIcon
};
